module.exports = __webpack_public_path__ + "static/img/23.51b1de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/23.png
// module id = JLEL
// module chunks = 0